import { RA, t } from '@werk85/prelude';
import * as fc from 'fast-check';
export * from 'fast-check';
export * from 'fp-ts-laws';
import * as either_1 from 'fp-ts-laws/lib/Either';
export { either_1 as either };
import * as option_1 from 'fp-ts-laws/lib/Option';
export { option_1 as option };
export function fromNewtype(arb) {
    return arb;
}
export function readonlyArray(arb, constraints = {}) {
    return fc.array(arb, constraints);
}
export function readonlyNonEmptyArray(arb, { minLength = 1, ...constraints } = { minLength: 1 }) {
    return readonlyArray(arb, { ...constraints, minLength: Math.max(1, minLength) }).filter(RA.isNonEmpty);
}
export function nonEmptyString({ minLength = 1, ...options } = { minLength: 1 }) {
    return fc.string({ ...options, minLength: Math.max(1, minLength) }).filter(t.NonEmptyString.is);
}
export function int() {
    return fc.integer().filter(t.Int.is);
}
export function keyof(codec) {
    return fc.oneof(...Object.keys(codec.keys).map(fc.constant));
}
export function intersection(a, b) {
    return fc.tuple(a, b).map(([a, b]) => ({ ...a, ...b }));
}
export function literal(value) {
    return fc.constant(value);
}
//# sourceMappingURL=fast-check.js.map